module.exports = __webpack_public_path__ + "img/step4-t.37c2e575.png";